import { memo } from 'react';
import { IconProps } from './iconType';

export const ArrowNextIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M5.32601 2.33288C5.23878 2.42217 5.18994 2.54205 5.18994 2.66688C5.18994 2.79171 5.23878 2.91159 5.32601 3.00088L10.199 7.99988L5.32601 12.9979C5.23878 13.0872 5.18994 13.207 5.18994 13.3319C5.18994 13.4567 5.23878 13.5766 5.32601 13.6659C5.3684 13.7094 5.41909 13.744 5.47508 13.7677C5.53108 13.7913 5.59123 13.8035 5.65201 13.8035C5.71278 13.8035 5.77294 13.7913 5.82893 13.7677C5.88492 13.744 5.93561 13.7094 5.97801 13.6659L11.16 8.34888C11.251 8.25551 11.302 8.13027 11.302 7.99988C11.302 7.86949 11.251 7.74425 11.16 7.65088L5.97801 2.33388C5.93561 2.29034 5.88492 2.25573 5.82893 2.2321C5.77294 2.20846 5.71278 2.19629 5.65201 2.19629C5.59123 2.19629 5.53108 2.20846 5.47508 2.2321C5.41909 2.25573 5.3684 2.29034 5.32601 2.33388V2.33288Z"
        fill={color}
      />
    </svg>
  );
});

ArrowNextIcon.displayName = 'ArrowNextIcon';
